var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipsisStrokeLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B192C",
    d: "M480,256c0,35.3-28.7,64-64,64s-64-28.7-64-64s28.7-64,64-64S480,220.7,480,256z M416,224 c-17.7,0-32,14.3-32,32s14.3,32,32,32s32-14.3,32-32S433.7,224,416,224z M320,256c0,35.3-28.7,64-64,64s-64-28.7-64-64 s28.7-64,64-64S320,220.7,320,256z M256,224c-17.7,0-32,14.3-32,32s14.3,32,32,32s32-14.3,32-32S273.7,224,256,224z M32,256 c0-35.3,28.65-64,64-64c35.3,0,64,28.7,64,64s-28.7,64-64,64C60.65,320,32,291.3,32,256z M96,288c17.7,0,32-14.3,32-32 s-14.3-32-32-32c-17.67,0-32,14.3-32,32S78.33,288,96,288z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisStrokeLight);
export default __webpack_public_path__ + "static/media/ellipsis-stroke-light.24ca3fe4728352c7d93dfcb24351c6b2.svg";
export { ForwardRef as ReactComponent };